import { Component, Prop, h } from '@stencil/core';
import { getConstant } from '../../../../utils/constants-helpers';
import { parseJsonProp } from '../../../../utils/helpers/hydration';

/**
 * Company logos component for SignNow brand showcasing client logos
 *
 * @product signnow
 * @version 1.0.0
 * @category logos
 * @contentConfig Company logos component for displaying trusted clients
 * @constant COMPANY_LOGOS_HEADING - "Forward-thinking companies around the world trust airSlate SignNow" - Main heading for company logos section
 */
@Component({
  tag: 'sn-company-logos-type-1',
  shadow: false,
})
export class SNCompanyLogosType1 {
  /**
   * Component constants object containing all required text constants
   */
  @Prop({ mutable: true }) constants?: Record<string, string> | string;

  componentWillLoad() {
    this.constants = parseJsonProp(this.constants);
  }

  /**
   * List of company logos to display
   * @dynamic
   * @type {array}
   * @.type {object}
   * @.property {string} src - Image source URL for the logo
   * @.property {string} alt - Image alt text for accessibility
   * @.required src
   * @.required alt
   * @minItems 4
   */
  @Prop() logos: any[] = [
    { src: 'https://marketing-static.signnow.com/323/images/home-new/logos/walmart.svg', alt: 'Walmart' },
    { src: 'https://marketing-static.signnow.com/323/images/home-new/logos/exonMobil.svg', alt: 'ExonMobil' },
    { src: 'https://marketing-static.signnow.com/323/images/home-new/logos/apple.svg', alt: 'Apple' },
    { src: 'https://marketing-static.signnow.com/323/images/home-new/logos/comcast.svg', alt: 'Comcast' },
    { src: 'https://marketing-static.signnow.com/323/images/home-new/logos/facebook.svg', alt: 'Facebook' },
    { src: 'https://marketing-static.signnow.com/323/images/home-new/logos/FedEx.svg', alt: 'FedEx' },
  ];

  /**
   * Display variant: default, column, or carousel
   */
  @Prop() variant: 'default' | 'column' | 'carousel' = 'carousel';

  /**
   * Enable/disable carousel autoplay
   */
  @Prop() autoplay: boolean = true;

  render() {
    const heading = getConstant(this.constants, 'COMPANY_LOGOS_HEADING', '');

    return (
      <company-logos-type-1 logos={this.logos} variant={this.variant} autoplay={this.autoplay}>
        {heading && (
          <me-heading slot="heading" tag="h2" variant="6">
            {heading}
          </me-heading>
        )}
      </company-logos-type-1>
    );
  }
}
